import { $ } from "venuescanner-js/tools/elemental";

const loadExternalLibrary = function (attrs) {
  // To not load script again
  let delay = 0;
  if (attrs.href !== undefined) {
    if ($('link[href="' + attrs.href + '"]').length > 0) {
      return;
    }
    setTimeout(
      function (atxtrs) {
        let style = document.createElement("link");
        style.rel = "stylesheet";
        style.href = attrs.href;
        document.body.appendChild(style);
      },
      delay,
      attrs
    );
  } else if (attrs.src !== undefined) {
    if ($('script[src="' + attrs.src + '"]').length > 0) {
      return;
    }

    // VSTODO: check if this script is maybe loaded already?
    setTimeout(
      function (atxtrs) {
        let script = document.createElement("script");

        if (attrs.src === undefined) {
          console.err("script will not load");
        }

        if (undefined === attrs.type) {
          attrs.type = "text/javascript";
        }

        const { onload, async, ...otherAttrs } = attrs;

        if (async) {
          script.async = true;
        }
        if (typeof onload === "function") {
          script.onload = attrs.onload;
        }

        for (let prop in otherAttrs) {
          if (otherAttrs.hasOwnProperty(prop)) {
            script.setAttribute(prop, attrs[prop]);
          }
        }

        document.body.appendChild(script);
      },
      delay,
      attrs
    );
  }
};

export default loadExternalLibrary;
